import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/_styles.scss";
import App from "./App";
import ThemeProvider from "./contexts/theme";
import { AiAssistantProvider } from "./contexts/AiAssistantContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AiAssistantProvider>
        <App />
      </AiAssistantProvider>
    </ThemeProvider>
  </React.StrictMode>
);
